"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = undefined;

var _hyperapp = require("hyperapp");

var Tooltip = exports.Tooltip = function Tooltip(_ref) {
  var state = _ref.state,
      length = _ref.length;
  return state.isVisible && (0, _hyperapp.h)(
    "div",
    { style: { left: state.left + "px" }, "class": "slideMode-Tooltip" },
    state.page + "/" + length
  );
};